import {CollectPolicyPostcodeRequest} from "@simplyhealth/iam_client_lib/lib";
import {createCognitoConfigSettings} from "../../../helpers/cognito-settings";

export function createCollectPolicyAndPostcodeRequest(
    email: string,
    dateOfBirth: string,
    lastName: string,
    policyNumber: string,
    postCode: string,
    jwtToken: string
): CollectPolicyPostcodeRequest {
    return {
        config: createCognitoConfigSettings(),
        email: email,
        dateOfBirth: new Date(dateOfBirth),
        surname: lastName,
        policyNo: policyNumber,
        postCode: postCode,
        jwtToken: jwtToken
    };
}
